const HANKYU_AUTH = {
  cookieName: 'hankyu_auth',
  cookieValue: 'H2O2026',
  storageKey:  'hankyu_auth'
};

const EXPIRY_MS = 24 * 60 * 60 * 1000;

function _getCookie(name) {
  const v = `; ${document.cookie}`;
  const parts = v.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function isAuthenticated() {
  if (_getCookie(HANKYU_AUTH.cookieName) === HANKYU_AUTH.cookieValue) return true;
  try {
    const raw = localStorage.getItem(HANKYU_AUTH.storageKey);
    if (!raw) return false;
    const data = JSON.parse(raw);
    if (data.v === HANKYU_AUTH.cookieValue && data.exp > Date.now()) return true;
    localStorage.removeItem(HANKYU_AUTH.storageKey);
    return false;
  } catch (e) {
    localStorage.removeItem(HANKYU_AUTH.storageKey);
    return false;
  }
}

function setAuthCookie() {
  const isHttps = location.protocol === 'https:';
  const base = `${HANKYU_AUTH.cookieName}=${HANKYU_AUTH.cookieValue}; path=/; Max-Age=86400`;
  document.cookie = isHttps ? `${base}; SameSite=Strict; Secure` : base;
  try {
    const data = JSON.stringify({ v: HANKYU_AUTH.cookieValue, exp: Date.now() + EXPIRY_MS });
    localStorage.setItem(HANKYU_AUTH.storageKey, data);
  } catch (e) {}
}

function requireAuth() {
  if (!isAuthenticated()) {
    window.location.href = '/pages/hankyu-hanshin_snack-bar-tour';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var gate = document.getElementById('hankyuGate');
  var nav  = document.getElementById('hankyuNav');

  if (!gate && !nav) return;

  document.documentElement.setAttribute('data-hankyu-tour', 'true');

  if (!gate || !nav) return;

  if (isAuthenticated()) {
    gate.hidden = true;
    nav.removeAttribute('hidden');
  }
});

window.handleLogin = function (e) {
  e.preventDefault();
  var pw    = document.getElementById('hankyuPassword').value;
  var error = document.getElementById('hankyuError');
  var gate  = document.getElementById('hankyuGate');
  var nav   = document.getElementById('hankyuNav');

  if (pw === HANKYU_AUTH.cookieValue) {
    setAuthCookie();
    gate.hidden = true;
    nav.removeAttribute('hidden');
    error.hidden = true;
  } else {
    error.hidden = false;
    document.getElementById('hankyuPassword').value = '';
  }
};
